import { useCallback } from "react";
import { REPORT_DETAIL_STORE_INSTANCE } from "~/store/details";

/**
 * Hook for toggling autosave functionality
 * Preference is automatically persisted to localStorage
 */
export function useAutoSaveToggle() {
  const { events } = REPORT_DETAIL_STORE_INSTANCE;

  const enableAutoSave = useCallback(() => {
    events.setAutoSaveEnabled(true);
  }, [events]);

  const disableAutoSave = useCallback(() => {
    events.setAutoSaveEnabled(false);
  }, [events]);

  return {
    enableAutoSave,
    disableAutoSave,
  };
}
